/**
 * Срок задачи в том виде, в каком он стоит на карточке: «12 авг».
 *
 * Через `Intl`, а не через dayjs с локалями: формат в макете — день и короткий
 * месяц, ровно то, что платформа умеет сама и на трёх языках сразу.
 */

/** `vn` — код страны в наших локалях; у языка он `vi`, и Intl знает только его */
const INTL_LOCALES: Record<string, string> = { vn: 'vi' }

/**
 * Год добавляем, только когда он не текущий: «12 авг» у задачи из следующего
 * декабря читалось бы как ближайший август, а год у каждого срока — это лишняя
 * колонка в футере, которого и так впритык.
 */
export const formatDueDate = (iso: string, locale: string, now = new Date()): string => {
  if (!iso) return ''

  const date = new Date(iso)

  if (Number.isNaN(date.getTime())) return ''

  const sameYear = date.getFullYear() === now.getFullYear()

  return (
    new Intl.DateTimeFormat(INTL_LOCALES[locale] ?? locale, {
      day: 'numeric',
      month: 'short',
      ...(sameYear ? {} : { year: 'numeric' }),
    })
      .format(date)
      // Русский отдаёт «12 авг. 2027 г.» — в макете ни сокращения года, ни
      // точки после месяца. Пробел перед «г.» обязателен: без него шаблон
      // съедает хвост самого «авг.».
      .replace(/\s+г\.$/, '')
      .replace(/\./g, '')
  )
}
